import { render } from "./CountDown.vue?vue&type=template&id=82e8c256&scoped=true&ts=true"
import script from "./CountDown.vue?vue&type=script&lang=ts"
export * from "./CountDown.vue?vue&type=script&lang=ts"

import "./CountDown.vue?vue&type=style&index=0&id=82e8c256&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e8c256"]])

export default __exports__